module.exports = __webpack_public_path__ + "static/media/licorDaJo.fe83b247.png";